export default __webpack_public_path__ + "static/media/PAFI_The Invitation of GMS 24 Juni 2024.991731f9.pdf";